import * as React from "react";
import TopBar from "./Ops.BillerCategories.GeneralTopBar";
import AllBillersContainer from "../../BillerCategories/AllBillersContainer";

export default class Billers extends React.Component<any, any> {
  componentDidMount() {
    this.props.setHeader({
      title: "Ops > BillerCategories",
      description: "SnapScan Billers"
    });
  }

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section className="padded scrollable">
          <AllBillersContainer name={"ops.biller_categories.billers"} />
        </section>
      </React.Fragment>
    );
  }
}
